import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'components/Button'
import { useCreateWizardDraft } from 'hooks/queries/wizardDrafts/useCreateWizardDraft'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { TextChannelKey } from 'types'

interface SaveDraftModalProps {
  currentStep: number
  completedAll: boolean
  values: any
  channel: string
  onClose?: () => void
}

export const SaveDraftModal = ({ values, currentStep, completedAll, channel, onClose }: SaveDraftModalProps) => {
  const { closeModals, closeModal } = useModals()
  const workspaceId = useCurrentWorkspaceId()
  const createWizardDraft = useCreateWizardDraft()

  const saveAsDraft = async () => {
    createWizardDraft.mutate(
      {
        values,
        step: currentStep,
        completed_all: completedAll,
        workspace_id: workspaceId,
        channel: channel as TextChannelKey,
      },
      {
        onSuccess: () => {
          closeModals(2)
        },
        onError: () => {
          closeModal()
        },
      },
    )
  }

  const handleCancel = () => {
    onClose?.()
    closeModals(2)
  }

  return (
    <Modal.Root>
      <Modal.Header title="Do you want to save your progress?" headingLevel={3} />
      <Modal.Content>
        <p>
          Want to save your work so you can pick it up later? Just head to “Create New” under the “Recently Used” tab to
          find your drafts.
        </p>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button onPress={handleCancel} size="lg" variant="tertiary">
            No, Just Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button onPress={saveAsDraft} size="lg">
            Yes, Save as Draft
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
